{
  "research-list-page": {
    "create-research-btn": "+ Створити дослідження",
    "filter": {
      "title": "Сортувати:",
      "label": "Опції сортування",
      "options": [
        { "name": "Датою створення (зменшення) ", "value": "createdAtDesc" },
        { "name": "Датою створення  (зростання)", "value": "createdAtAsc" },
        { "name": "Алфавітом (А-Я)", "value": "alphabetAsc" },
        { "name": "Алфавітом (Я-А)", "value": "alphabetDesc" }
      ]
    },

    "research-card": {
      "stats": {
        "participants-count": "Кількість учасників: {{count}}",
        "createdAt": "Створено: {{date}}"
      },
      "action": {
        "results": "Переглянути результати",
        "edit-participants": "Редагувати учасників",
        "finish-research": "Завершити дослідження",
        "finished-research": "Завершене дослідження"
      },
      "complete-research-dialog": {
        "title": "Якщо ви завершите дослідження — створення нових етапів буде неможливе",
        "complete": "Завершити дослідження",
        "close": "Скасувати"
      },

      "research-step-card": {
        "step": "Eтап {{index}}",
        "stats-description": "Пройшли / Всього учасників",
        "started-at": "Дата початку: {{date}}",
        "finished-at": "Дата завершення: {{date}}",
        "button-state": {
          "finished": "Завершено",
          "finish": "Завершити",
          "start": "Розпочати"
        }
      },
      "create-research-step-card": {
        "title": "Новий етап",
        "button": "Створити етап"
      }
    }
  },

  "participants-page": {
    "title": "Список учасників",
    "warning-message": "Ви не зможете змінити склад списку учасників після завершення першого етапу дослідження",
    "breadcrumbs": [
      { "value": "results", "name": "Результати дослідження" },
      {
        "value": "participants",
        "name": "Список учасників"
      }
    ]
  },

  "create-research-funnel": {
    "layout": {
      "breadcrumbs-page-title": "Cтворення нового списку учасників"
    },

    "header-texts": [
      {
        "title": "Крок 1. Назва дослідження",
        "description": "Список учасників - люди, які беруть участь у поточному дослідженні."
      },
      {
        "title": "Крок 2. Додавання груп учасників",
        "description": "Зараз ви можете додати групи. Якщо потрібно додати окремого учасника — це можна зробити на наступному кроці."
      },
      {
        "title": "Крок 3. Додавання окремих учасників",
        "description": "На цьому кроці ви можете обрати окремих учасників та переглянути список нижче."
      },
      {
        "title": "Крок 4. Редагування списку учасників",
        "description": "Перевірте список учасників. Змінити його можна лише до завершення першого етапу дослідження."
      }
    ],

    "first-step-research-name": {
      "warning-message": "Ви не зможете змінити склад списку учасників після завершення першого етапу дослідження",
      "input-label": "Вкажіть назву дослідження",
      "input-placeholder": "Назва дослідження",
      "unique-research-name-error": "Назва дослідження має бути унікальною."
    },
    "third-step-research-users": {
      "input-label": "Введіть e-mail учасника",
      "input-placeholder": "mail@mail.com",
      "input-error-message": "Учасник вже доданий в дослідження {{name}}",
      "warning-message": "Треба завершити активне дослідження для додавання учасника до нового",
      "add-all-btn": "Додати всіх учасників організації",
      "add-or-select": "Або самостійно оберіть учасників:",
      "selected-users": "Обрані учасники"
    },

    "controls": {
      "confirm": "Підтвердити"
    }
  },
  "add-participants": {
    "groups": {
      "title": "Додати групи учасників",
      "description": "Тут ви можете додати групи. Якщо потрібно додати окремого учасника — це можна зробити на наступному кроці."
    },
    "users": {
      "title": "Додавання окремих учасників",
      "description": "Тут ви можете обрати окремих учасників та переглянути список нижче."
    },
    "actions": {
      "cancel": "Скасувати",
      "next": "Далі",
      "back": "Назад",
      "confirm": "Підтвердити"
    }
  }
}
